<template>

  <div v-if="isLoginUserPageUserReadable">

    <userTabs v-if="!presentationMode" :current="'list'" :pageUser="pageUser">

      <b-button v-if="adminDevices != null && !loginUserDeepBinding" @click="toggleAdminDevicesRealtimeChanged" size="sm" :variant="(adminDevicesBinded)? 'primary' : 'secondary'" class="tabButton float-right mr-2" v-b-tooltip.hover title="내가 관리자로 등록된 기기의 실시간 동작여부. 일정 시간이 지나면 실시간이 꺼집니다.">
        @admin
        <span v-if="adminDevicesBinded" class="displayNoneMax589">켜짐</span>
        <span v-else class="displayNoneMax589">꺼짐</span>
      </b-button>

      <b-button v-if="friendDevices != null" @click="toggleFriendDevicesRealtimeChanged" size="sm" :variant="(friendDevicesBinded)? 'primary' : 'secondary'" class="tabButton float-right mr-2" v-b-tooltip.hover title="내가 친구로 등록된 기기의 실시간 동작여부. 일정 시간이 지나면 실시간이 꺼집니다.">
        @friend
        <span v-if="friendDevicesBinded" class="displayNoneMax589">켜짐</span>
        <span v-else class="displayNoneMax589">꺼짐</span>
      </b-button>

      <b-button v-if="oAdminDevices != null" @click="toggleOAdminDevicesRealtimeChanged" size="sm" :variant="(oAdminDevicesBinded)? 'danger' : 'secondary'" class="tabButton float-right mr-2" v-b-tooltip.hover title="내가 원관리자인 기기의 실시간 동작여부. 일정 시간이 지나면 실시간이 꺼집니다.">
        @oAdmin
        <span v-if="oAdminDevicesBinded" class="displayNoneMax589">켜짐</span>
        <span v-else class="displayNoneMax589">꺼짐</span>
      </b-button>

    </userTabs>

    <div class="controlRow" v-if="!presentationMode" style="margin-top: 0.4rem;">
      <div class="leftExpandControl">
        <label for="uiView" class="mr-1 fontSizeDot9 displayNoneMax630">보기</label>
        <b-form-select id="uiView" v-model="uiView" @change="applyUiView" size="sm" class="mr-2 fontSizeDot8 rounded-0" :options="uiViewOptions"></b-form-select>
        <label for="uiOrderBy" class="mr-1 fontSizeDot9 displayNoneMax630">정렬</label>
        <b-form-select id="uiOrderBy" v-model="uiOrderBy" @change="applyUiOrderBy" size="sm" class="mr-2 fontSizeDot8 rounded-0" :options="[
          {'text': '지정된 순서' , 'value': 'saved' },
          {'text': '수정 일시' , 'value': 'modified' },
          {'text': '데이터 수' , 'value': 'row' },
          {'text': '생성 일시' , 'value': 'created' },
          {'text': '기기 이름' , 'value': 'name' },
        ]"></b-form-select>
        <label for="uiKeyword" class="mr-1 fontSizeDot9 displayNoneMax630">필터</label>
        <b-form-input  v-touch:swipe.stop id="uiKeyword" class="fontSizeDot8 rounded-0 form-control form-control-sm  narrowText2" v-model="uiKeyword" trim size="sm" placeholder="제목, 설명, 위치정보"/>
      </div>

      <div class="rightControl">
        <b-form-select id="uiOption" v-model="uiOption" @change="applyUiOption" size="sm" class="fontSizeDot8 rounded-0" :options="[
          {'text': '데이터 우선' , 'value': 'data' },
          {'text': '사진 우선' , 'value': 'photo' },
          {'text': '설명 우선' , 'value': 'desc' },
          {'text': '위치 우선' , 'value': 'location' }
        ]"></b-form-select>
      </div>

    </div>

    <tinkList v-touch:swipe.stop v-if="isLoginUserPageUser" :show="-1" :controls="false" class="p-0 m-0 mb-1 mt-2" rowClass="deviceListTinkListRow" :lastLinePrevWidth="true" ref="tinkList">

      <tinkListItem v-if="uiView=='folder'&& folder=='@root' && (friendDevices == null || friendDevices.length != 0)" class="deviceListTinkListFolderItem p-0 m-1">

        <h3 class="device-title border border-success-dark m-0 p-1 pl-2 borderTopRounded bg-success-light">
          <span v-if="marker=='@friend'" class="text-danger">&starf;</span>
          <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': '@admin' } }" custom v-slot="{ navigate }">
            <div @click="navigate" @keypress.enter="navigate" role="link" class="btn float-right bg-success text-light d-inline-block m-0 mt-dot1 mr-1 p-0 pl-2 pr-2 fontSizeDot8 narrowText2 cursor-pointer" v-b-tooltip.hover.top title="나를 친구로 등록한 기기들">
              폴더
            </div>
          </router-link>
          <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': '@friend' } }"  v-b-tooltip.hover.top title="나를 친구로 등록한 기기들" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              @friend
            </span>  
          </router-link>
        </h3>

        <div class="deviceListTinkSlide border border-top-0 border-success-dark">
          <div class="deviceListTinkSlideItem p-2 pl-3 gothic fontSizeDot8 bg-success-lighter">

            <div v-if="friendDevices != null" class="narrowText2">
              <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': '@friend' } }" custom v-slot="{ navigate }">
                <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                  전체 {{ friendDevices.length }} 개 기기
                </span>  
              </router-link>
            </div>
            <div v-else class="text-center mt-5">
              <b-button @click="bindFriendDevices" size="sm" variant="success" class="pt-dot1 pb-dot1 pl-3 pr-3">조회</b-button>
            </div>

            <ul v-if="friendDevices != null" class="m-0 p-0 pl-3 narrowText2 fontSizeDot8" style="line-height: 130%;">
              <li class="p-0 ml-1 m-0" v-for="device in friendDevices.filter((item,index)=> (index < 4))" :key="`folderDevice_atFriend_${device.id}`">
                <router-link :to="{ name: 'tinkDevice', params: { 'did': device.id } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    {{device.name}}
                  </span>  
                </router-link>
              </li>
              <li class="p-0 ml-1 m-0" v-if="friendDevices.length > 4">
                <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': '@friend' } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    외 {{friendDevices.length-4}} 개
                  </span>  
                </router-link>
              </li>
            </ul>

          </div>
        </div>
        <div class="m-0 pl-2 pr-2 pt-1 pb-1 border border-top-0 border-success-dark fontSizeDot8 gothic text-center borderBottomRounded narrowText2">
          <span v-if="friendDevices != null">
            수정: {{deviceListLastModifiedDateString(friendDevices)}}
          </span>
          <span v-else>
            수정: 알 수 없음
          </span>
        </div>
      </tinkListItem>

      <tinkListItem v-if="uiView=='folder'&& folder=='@root' && (oAdminDevices == null || oAdminDevices.length != 0)" class="deviceListTinkListFolderItem p-0 m-1">

        <h3 class="device-title border border-danger-dark m-0 p-1 pl-2 borderTopRounded bg-danger-light">
          <span v-if="marker=='@oAdmin'" class="text-danger">&starf;</span>
          <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': '@admin' } }" custom v-slot="{ navigate }">
            <div @click="navigate" @keypress.enter="navigate" role="link" class="btn float-right bg-danger text-white d-inline-block m-0 mt-dot1 mr-1 p-0 pl-2 pr-2 fontSizeDot8 narrowText2 cursor-pointer" v-b-tooltip.hover.top title="내가 원관리자인 기기들">
              폴더
            </div>
          </router-link>
          <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': '@oAdmin' } }"  v-b-tooltip.hover.top title="내가 원관리자인 기기들" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              @oAdmin
            </span>  
          </router-link>
        </h3>

        <div class="deviceListTinkSlide border border-top-0 border-danger-dark">
          <div class="deviceListTinkSlideItem p-2 pl-3 gothic fontSizeDot8 bg-danger-lighter">

            <div v-if="oAdminDevices != null" class="narrowText2">
              <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': '@oAdmin' } }" custom v-slot="{ navigate }">
                <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                  전체 {{ oAdminDevices.length }} 개 기기
                </span>  
              </router-link>
            </div>
            <div v-else class="text-center mt-5">
              <b-button @click="bindOAdminDevices" size="sm" variant="danger" class="pt-dot1 pb-dot1 pl-3 pr-3">조회</b-button>
            </div>

            <ul v-if="oAdminDevices != null" class="m-0 p-0 pl-3 narrowText2 fontSizeDot8" style="line-height: 130%;">
              <li class="p-0 ml-1 m-0" v-for="device in oAdminDevices.filter((item,index)=> (index < 4))" :key="`folderDevice_atOAdmin_${device.id}`">
                <router-link :to="{ name: 'tinkDevice', params: { 'did': device.id } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    {{device.name}}
                  </span>  
                </router-link>
              </li>
              <li class="p-0 ml-1 m-0" v-if="oAdminDevices.length > 4">
                <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': '@oAdmin' } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    외 {{oAdminDevices.length-4}} 개
                  </span>  
                </router-link>
              </li>
            </ul>

          </div>
        </div>
        <div class="m-0 pl-2 pr-2 pt-1 pb-1 border border-top-0 border-danger-dark fontSizeDot8 gothic text-center borderBottomRounded narrowText2">
          <span v-if="oAdminDevices != null">
            수정: {{deviceListLastModifiedDateString(oAdminDevices)}}
          </span>
          <span v-else>
            수정: 알 수 없음
          </span>
        </div>
      </tinkListItem>

      <tinkListItem v-if="uiView=='folder'&& folder=='@root' && (adminDevices == null || adminDevices.length != 0)" class="deviceListTinkListFolderItem p-0 m-1">
        <h3 class="device-title border border-info-dark m-0 p-1 pl-2 borderTopRounded bg-info-light">
          <span v-if="marker=='@admin'" class="text-danger">&starf;</span>
          <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': '@admin' } }" custom v-slot="{ navigate }">
            <div @click="navigate" @keypress.enter="navigate" role="link" class="btn float-right bg-info text-light d-inline-block m-0 mt-dot1 mr-1 p-0 pl-2 pr-2 fontSizeDot8 narrowText2 cursor-pointer" v-b-tooltip.hover.top title="나를 관리자로 지정한 기기들">
              폴더
            </div>
          </router-link>
          <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': '@admin' } }" v-b-tooltip.hover.top title="나를 관리자로 지정한 기기들" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              @admin
            </span>  
          </router-link>
        </h3>
        <div class="deviceListTinkSlide border border-top-0 border-info-dark">

          <div class="deviceListTinkSlideItem p-2 pl-3 gothic fontSizeDot8 bg-info-lighter narrowText2">

            <div v-if="adminDevices != null" class="narrowText2">
              <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': '@admin' } }" custom v-slot="{ navigate }">
                <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                  전체 {{ adminDevices.length }} 개 기기
                </span>  
              </router-link>
            </div>
            <div v-else class="text-center mt-5">
              <b-button @click="bindAdminDevices" size="sm" variant="info" class="pt-dot1 pb-dot1 pl-3 pr-3">조회</b-button>
            </div>

            <ul v-if="adminDevices != null" class="m-0 p-0 pl-3" style="line-height: 130%;">
              <li class="p-0 ml-1 m-0" v-for="device in adminDevices.filter((item,index)=> (index < 4))" :key="`folderDevice_atAdmin_${device.id}`">
                <router-link :to="{ name: 'tinkDevice', params: { 'did': device.id } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    {{device.name}}
                  </span>  
                </router-link>
              </li>
              <li class="p-0 ml-1 m-0" v-if="adminDevices.length > 4" style="line-height: 130%;">
                <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': '@admin' } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    외 {{adminDevices.length-4}} 개
                  </span>  
                </router-link>
              </li>
            </ul>

          </div>

        </div>
        <div class="m-0 pl-2 pr-2 pt-1 pb-1 border border-top-0 border-info-dark fontSizeDot8 gothic text-center borderBottomRounded narrowText2">
          <span v-if="adminDevices != null">
            수정: {{folderLastModifiedDateString('@admin')}}
          </span>
          <span v-else>
            수정: 알 수 없음
          </span>
        </div>
      </tinkListItem>

      <tinkListItem v-for="folderItem in uiViewFolderFolders" :key="folderItem" class="deviceListTinkListFolderItem p-0 m-1">
        <h3 class="device-title border border-warning-dark m-0 p-1 pl-2 borderTopRounded bg-warning-light">
          <span v-if="marker==folderItem" class="text-danger">&starf;</span>
          <router-link v-if="folderItem=='@root'" :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': folderItem } }" custom v-slot="{ navigate }">
            <div @click="navigate" @keypress.enter="navigate" role="link" class="btn float-right bg-warning d-inline-block m-0 mt-dot1 mr-1 p-0 pl-2 pr-2 fontSizeDot8 narrowText2 cursor-pointer">
              최상위 폴더
            </div>
          </router-link>
          <router-link v-else :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': folderItem } }" custom v-slot="{ navigate }">
            <div @click="navigate" @keypress.enter="navigate" class="btn float-right bg-warning d-inline-block m-0 mt-dot1 mr-1 p-0 pl-2 pr-2 fontSizeDot8 cursor-pointer">
              폴더
            </div>
          </router-link>

          <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': folderItem } }" custom v-slot="{ navigate }">
            <span v-if="folder !='@root' && uiView=='folder' && folderItem == '@root'" @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              ..
            </span>
            <span v-else @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              {{ folderItem }}
            </span>
          </router-link>
        </h3>
        <div class="deviceListTinkSlide border border-top-0 border-warning-dark narrowText2">
          <div v-if="folderItem=='@root'" class="deviceListTinkSlideItem p-2 pl-3 gothic fontSizeDot8 bg-warning-lighter">
            <ul class="m-0 p-0 pl-3" style="line-height: 130%;">
              <li class="p-0 pb-1 ml-1 m-0" v-if="adminDevices != null && adminDevices.length > 0">
                <router-link v-if="'@oAdmin' != folder" :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': '@admin' } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    @admin 폴더: 기기
                    {{ adminDevices.length }}
                    개
                  </span>  
                </router-link>
                <span v-else>
                  @admin 폴더: 기기
                  {{ adminDevices.length }}
                  개 (현재)
                </span>
              </li>

              <li class="p-0 pb-1 ml-1 m-0" v-if="oAdminDevices != null && oAdminDevices.length > 0">
                <router-link v-if="'@oAdmin' != folder" :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': '@oAdmin' } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    @oAdmin 폴더: 기기
                    {{ oAdminDevices.length }}
                    개
                  </span>  
                </router-link>
                <span v-else>
                  @oAdmin 폴더: 기기
                  {{ oAdminDevices.length }}
                  개 (현재)
                </span>
              </li>

              <li class="p-0 pb-1 ml-1 m-0" v-if="friendDevices != null && friendDevices.length !=0">
                <router-link v-if="'@friend' != folder" :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': '@friend' } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    @friend 폴더: 기기
                    {{ friendDevices.length }}
                    개
                  </span>  
                </router-link>
                <span v-else>
                  @friend 폴더: 기기
                  {{ friendDevices.length }}
                  개 (현재)
                </span>
              </li>

              <li class="p-0 pb-1 ml-1 m-0" v-for="(subFolder,subFolderIndex) in loginUser.folders.filter(item => {
                if(loginUserDeviceInfoGroupByFolder[item].length == 0) return false;
                else return true;
                })" :key="`folderDeviceSubFolder_${subFolder}_${subFolderIndex}`">
                <router-link v-if="subFolder != folder" :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': subFolder } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    {{ subFolder }}
                    폴더: 기기
                    {{ loginUserDeviceInfoGroupByFolder[subFolder].length }}
                    개
                  </span>  
                </router-link>
                <span v-else>
                  {{ subFolder }}
                  폴더: 기기
                  {{ loginUserDeviceInfoGroupByFolder[subFolder].length }}
                  개 (현재)
                </span>
              </li>
            </ul>
          </div>
          <div v-else class="deviceListTinkSlideItem p-2 pl-3 gothic fontSizeDot8 bg-warning-lighter">
            <div class="pb-1" v-if="loginUserDeviceInfoGroupByFolder[folderItem].length == 0">
              기기 없음
            </div>
            <div class="pb-1" v-if="loginUserDeviceInfoGroupByFolder[folderItem].length > 0">
              <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': folderItem } }" custom v-slot="{ navigate }">
                <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                  전체 {{ loginUserDeviceInfoGroupByFolder[folderItem].length }} 개 기기
                </span>  
              </router-link>
            </div>
            <ul class="m-0 p-0 pl-3" style="line-height: 130%;" v-if="loginUserDeviceInfoGroupByFolder[folderItem].length > 0">
              <li class="p-0 pb-1 ml-1 m-0" v-for="device in loginUserDeviceInfoGroupByFolder[folderItem].sort((a,b)=>{
                aLastModified = deviceSensorsLastModified(loginUser.devices[a.id]);
                bLastModified = deviceSensorsLastModified(loginUser.devices[b.id]);
                if(aLastModified.seconds > bLastModified.seconds) {
                  return -1;
                }
                else if(aLastModified.seconds < bLastModified.seconds) {
                  return 1;
                }
                else {
                  return 0;
                }
                }).filter((item,index)=> (index < 4))" :key="`folderDevice_${folderItem}_${device.id}`">
                <router-link :to="{ name: 'tinkDevice', params: { 'did': device.id } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    {{device.name}}
                  </span>  
                </router-link>
              </li>
              <li class="p-0 pb-1 ml-1 m-0" v-if="loginUserDeviceInfoGroupByFolder[folderItem].length > 4" style="line-height: 130%;">
                <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': folderItem } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    외 {{loginUserDeviceInfoGroupByFolder[folderItem].length-4}} 개
                  </span>  
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="m-0 pl-2 pr-2 pt-1 pb-1 border border-top-0 border-warning-dark fontSizeDot8 gothic text-center borderBottomRounded narrowText2">
          수정: {{folderLastModifiedDateString(folderItem)}}
        </div>
      </tinkListItem>

      <tinkListItem v-for="pageDevice in sortAndFilteredDevices" :key="pageDevice.id" class="deviceListTinkListItem p-0 m-1">

        <h3 class="device-title border border-secondary m-0 p-1 pl-2 bg-light">
          <span v-if="marker==pageDevice.id" class="text-danger">&starf;</span>

          <b-button v-if="pageDevice.owner == loginUser.id" size="sm" class="float-right d-inline-block m-0 mt-dot1 mr-1 p-0 pl-2 pr-2 fontSizeDot8 narrowText2" :disabled ="false" @click="deviceActiveChanged" :data-did="pageDevice.id" :data-active="pageDevice.active" :variant="(pageDevice.active)? 'danger': 'secondary'">
            {{ (pageDevice.active)? '켜짐' : '꺼짐' }}
          </b-button>

          <router-link v-else custom v-slot="{ navigate }" :to="{ 'name': 'tinkDevice', 'params': { 'did': pageDevice.id }}">
            <div @click="navigate" @keypress.enter="navigate" role="link" class="float-right btn bg-info text-light d-inline-block m-0 mt-dot1 mr-1 p-0 pl-2 pr-2 fontSizeDot8 cursor-pointer" v-b-tooltip.hover.top>
              <span v-if="folder == '@friend'">친구</span>
              <span v-else-if="folder == '@oAdmin'">원관리자</span>
              <span v-else>관리자</span>
            </div>
          </router-link>

          <router-link :to="{ name: 'tinkDevice', params: { did: pageDevice.id} }" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              {{ pageDevice.name }}
            </span>  
          </router-link>
        </h3>

        <tinkSlide class="deviceListTinkSlide border border-top-0 border-secondary" controlsPosition="custom" :controlsHeight="-1" controlPrevClass="deviceListTinkSlidePrev" controlNextClass="deviceListTinkSlideNext" :controlPrev="false" :controlNext="true" :controls="true" :swipeDisabled="true" :tabDisabled="false" :autoRotate="0" :onHeightChange="obj=>obj.$parent.$parent.resetHeight()">

          <tinkSlideItem  name="desc" class="deviceListTinkSlideItem p-2 pb-1 gothic fontSizeDot9" :show="uiOption == 'desc'" v-if="pageDevice.description != ''" v-html="pageDevice.description">
          </tinkSlideItem>

          <tinkSlideItem name="photo" v-if="pageDevice.photoURL != ''" class="deviceListTinkSlideItem" :show="uiOption == 'photo'">
            <b-img center :src="pageDevice.photoURL" class="tinkSlideItemPhoto"/>
          </tinkSlideItem>

          <tinkSlideItem name="data" v-if="pageDevice.sensors && Object.entries(pageDevice.sensors).filter(item => item[1].lastValues != null).length != 0" class="deviceListTinkSlideItem p-2 pb-1" :show="uiOption == 'data'">

            <div v-for="(sensor,sensorIndex) in Object.entries(pageDevice.sensors).filter(item => item[1].lastValues != null)" :key="sensor[1].id" :class="(sensorIndex != (Object.entries(pageDevice.sensors).filter(item => item[1].lastValues != null).length-1))? 'mb-1 border-bottom border-gray': ''">

              <div class="d-flex flex-nowrap justify-content-between mb-1" v-for="(value, index) in sensor[1].values.filter(item => item.hold !== true)" :key="index">
                <div class="text-left fontSizeDot8 gothic mr-auto flex-grow-1">
                  <router-link :to="{ name: 'tinkSensor', params: { 'sid': sensor[1].id } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{ value.title }}
                    </span>  
                  </router-link>
                </div>
                <div v-if="value.type == 'string'" class="text-right pr-1 fontSizeDot9 font-weight-bold">
                  {{ sensor[1].lastValues.v[index] }}
                </div>
                <div v-else class="text-right pr-1 fontSizeDot9 font-weight-bold">
                  {{ sensor[1].lastValues.v[index].toLocaleString("ko-KR") }}
                </div>
                <div class="text-left fontSizeDot8 ml-auto">
                  {{ value.unit }}
                </div>
              </div>
            </div>
          </tinkSlideItem>

          <tinkSlideItem name="location" v-if="pageDevice.locationInfo || pageDevice.location" class="deviceListTinkSlideItem p-2 pb-1 fontSizeDot8" :show="uiOption == 'location'">
            <ul class="m-0 p-0 pl-3" style="line-height: 140%;">
              <li v-if="pageDevice.location" class="p-0 pb-1 m-0">
                <router-link v-if="isLoginUserPageUser||isLoginUserAdmin" :to="{ name: 'tinkUser', params: { uid: loginUser.id, mode: 'map', marker: pageDevice.id } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    {{geopointToDMSString(pageDevice.location)}}
                  </span>  
                </router-link>
                <span v-if="!(isLoginUserPageUser||isLoginUserAdmin)" style="color: #0004af; cursor: pointer" @click="openNewGmapWindow(pageDevice.location.latitude, pageDevice.location.longitude)">
                  {{geopointToDMSString(pageDevice.location)}}
                </span>
              </li>
              <li v-if="pageDevice.locationInfo && pageDevice.locationInfo.name && !pageDevice.locationInfo.place_id" class="p-0 pb-1 m-0">
                {{pageDevice.locationInfo.name}}
              </li>
              <li v-if="pageDevice.locationInfo && pageDevice.locationInfo.name && pageDevice.locationInfo.place_id" class="p-0 pb-1 m-0">
                <a :href="`https://www.google.com/maps/place/?q=place_id:${pageDevice.locationInfo.place_id}`" target="_new">{{pageDevice.locationInfo.name}}</a> &nearr;
              </li>
              <li v-if="pageDevice.locationInfo && pageDevice.locationInfo.formatted_address" class="p-0 pb-1 m-0">
                {{pageDevice.locationInfo.formatted_address}}
              </li>
              <li v-if="pageDevice.locationInfo && pageDevice.locationInfo.international_phone_number" class="p-0 pb-1 m-0">
                {{pageDevice.locationInfo.international_phone_number}}
              </li>
              <li v-if="pageDevice.locationInfo && pageDevice.locationInfo.website" class="p-0 pb-1 m-0">
                <a :href="pageDevice.locationInfo.website" target="_new">{{pageDevice.locationInfo.website}}</a> &nearr;
              </li>
            </ul>
          </tinkSlideItem>
        </tinkSlide>


        <div class="m-0 pl-2 pr-2 pt-1 pb-1 border border-top-0 border-secondary fontSizeDot8 gothic text-center narrowText2">
          수정: {{ deviceSensorsLastModifiedDateString(pageDevice) }}
        </div>
      </tinkListItem>

      <tinkListItem v-if="(adminDevices == null || adminDevices.length==0) && folder == '@root' && (!sortAndFilteredDevices || sortAndFilteredDevices.length == 0)" class="deviceListTinkListItem p-0 m-1">
        <div class="border border-gray p-2 fontSizeDot9 gothic text-center" style="height: 100%;">
          <div class="p-1 mt-3">등록된 기기 없음</div>
          <div v-if="isLoginUserPageUser" class="p-1">
            <router-link :to="{ name: 'tinkUser', params: { uid : loginUser.id }, query: { mode: 'add', action : 'addDevice' }}" v-slot="{ navigate }">
              <b-button @click="navigate" @keypress.enter="navigate" role="link" variant="primary" size="sm">기기 등록하기</b-button>
            </router-link>
          </div>
        </div>
      </tinkListItem>

    </tinkList>

    <tinkList v-touch:swipe.stop v-else :show="-1" :controls="false" class="p-0 m-0 mb-1 mt-1" rowClass="deviceListTinkListRow" :lastLinePrevWidth="true" ref="tinkList">

      <tinkListItem v-for="folderItem in uiViewFolderFolders" :key="folderItem" class="deviceListTinkListFolderItem p-0 m-1 bg-warning-lighter">
        <h3 class="device-title border border-secondary m-0 p-1 pl-2 borderTopRounded bg-warning-light">
          <span v-if="marker=='@root'" class="text-danger">&starf;</span>
          <router-link v-if="folderItem=='@root'" :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': folderItem } }" custom v-slot="{ navigate }">
            <b-button @click="navigate" @keypress.enter="navigate" role="link" size="sm" variant="warning" class="float-right d-inline-block m-0 mt-dot1 mr-1 p-0 pl-2 pr-2 fontSizeDot8 narrowText2 cursor-pointer">
              최상위 폴더
            </b-button>
          </router-link>
          <router-link v-else :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': folderItem } }" custom v-slot="{ navigate }">
            <b-button @click="navigate" @keypress.enter="navigate" role="link" size="sm" variant="warning" class="float-right d-inline-block m-0 mt-dot1 mr-1 p-0 pl-2 pr-2 fontSizeDot8 narrowText2 cursor-pointer">
            폴더
            </b-button>
          </router-link>

          <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': folderItem } }" custom v-slot="{ navigate }">
            <span v-if="folder !='@root' && uiView=='folder' && folderItem == '@root'" @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              ..
            </span>
            <span v-else @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              {{ folderItem }}
            </span>
          </router-link>
        </h3>
        <div class="deviceListTinkSlide border border-top-0 border-secondary bg-warning-lighter narrowText2">
          <div v-if="folderItem=='@root'" class="deviceListTinkSlideItem p-2 gothic fontSizeDot8">
            <ul class="m-0 p-0 pl-3" style="line-height: 130%;">

              <li class="p-0 pb-1 ml-1 m-0" v-for="(subFolder,subFolderIndex) in pageUser.folders.filter(item => {
                if(pageUserDeviceInfoGroupByFolder[item].length == 0) return false;
                else return true;
                })" :key="`folderDeviceSubFolder_${subFolder}_${subFolderIndex}`">
                <router-link v-if="subFolder != folder" :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': subFolder } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    {{ subFolder }}
                    폴더: 기기
                    {{ pageUserDeviceInfoGroupByFolder[subFolder].length }}
                    개
                  </span>  
                </router-link>
                <span v-else>
                  {{ subFolder }}
                  폴더: 기기
                  {{ pageUserDeviceInfoGroupByFolder[subFolder].length }}
                  개 (현재)
                </span>
              </li>
            </ul>
          </div>
          <div v-else class="deviceListTinkSlideItem p-2 gothic fontSizeDot8">
            <div class="pb-1" v-if="pageUserDeviceInfoGroupByFolder[folderItem].length == 0">
              기기 없음
            </div>
            <div class="pb-1" v-if="pageUserDeviceInfoGroupByFolder[folderItem].length > 0">
              <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': folderItem } }" custom v-slot="{ navigate }">
                <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                  전체 {{ pageUserDeviceInfoGroupByFolder[folderItem].length }} 개 기기
                </span>  
              </router-link>
            </div>
            <ul class="m-0 p-0 pl-3" style="line-height: 130%;" v-if="pageUserDeviceInfoGroupByFolder[folderItem].length > 0">
              <li class="p-0 pb-1 ml-1 m-0" v-for="device in pageUserDeviceInfoGroupByFolder[folderItem].sort((a,b)=>{
                aLastModified = deviceSensorsLastModified(pageUser.devices[a.id]);
                bLastModified = deviceSensorsLastModified(pageUser.devices[b.id]);
                if(aLastModified.seconds > bLastModified.seconds) {
                  return -1;
                }
                else if(aLastModified.seconds < bLastModified.seconds) {
                  return 1;
                }
                else {
                  return 0;
                }
                }).filter((item,index)=> (index < 4))" :key="`folderDevice_${folderItem}_${device.id}`">
                <router-link :to="{ name: 'tinkDevice', params: { 'did': device.id } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    {{device.name}}
                  </span>  
                </router-link>
              </li>
              <li class="p-0 pb-1 ml-1 m-0" v-if="pageUserDeviceInfoGroupByFolder[folderItem].length > 4" style="line-height: 130%;">
                <router-link :to="{ name: 'tinkUserFolder', params: { 'uid': uid, 'folder': folderItem } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    외 {{pageUserDeviceInfoGroupByFolder[folderItem].length-4}} 개
                  </span>  
                </router-link>
              </li>
            </ul>
          </div>
        </div>

        <div class="m-0 pl-2 pr-2 pt-1 pb-1 border border-top-0 border-secondary fontSizeDot8 gothic text-center borderBottomRounded narrowText2">
          수정: {{folderLastModifiedDateString(folderItem)}}
        </div>
      </tinkListItem>

      <tinkListItem v-for="pageDevice in sortAndFilteredDevices" :key="pageDevice.id" class="deviceListTinkListItem p-0 m-1">
        <h3 class="device-title border border-secondary m-0 p-1 pl-2 bg-light">
          <span v-if="marker==pageDevice.id" class="text-danger">&starf;</span>
          <b-button v-if="isLoginUserPageUser||isLoginUserAdmin" size="sm" class="float-right d-inline-block m-0 mt-dot1 mr-1 p-0 pl-2 pr-2 fontSizeDot8 narrowText2" :disabled ="false" @click="deviceActiveChanged" :data-did="pageDevice.id" :data-active="pageDevice.active" :variant="(pageDevice.active)? 'danger': 'secondary'">
            {{ (pageDevice.active)? '켜짐' : '꺼짐' }}
          </b-button>
          <router-link :to="{ name: 'tinkDevice', params: { did: pageDevice.id} }" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              {{ pageDevice.name }}
            </span>  
          </router-link>
        </h3>

        <tinkSlide class="deviceListTinkSlide border border-top-0 border-secondary" controlsPosition="custom" :controlsHeight="-1" controlPrevClass="deviceListTinkSlidePrev" controlNextClass="deviceListTinkSlideNext" :controlPrev="false" :controlNext="true" :controls="true" :swipeDisabled="true" :tabDisabled="false" :autoRotate="0" :onHeightChange="obj=>obj.$parent.$parent.resetHeight()">

          <tinkSlideItem  name="desc" class="deviceListTinkSlideItem p-2 pb-1 gothic fontSizeDot9" :show="uiOption == 'desc'" v-if="pageDevice.description != ''" v-html="pageDevice.description">
          </tinkSlideItem>

          <tinkSlideItem name="photo" v-if="pageDevice.photoURL != ''" class="deviceListTinkSlideItem" :show="uiOption == 'photo'">
            <b-img center :src="pageDevice.photoURL" class="tinkSlideItemPhoto"/>
          </tinkSlideItem>

          <tinkSlideItem name="data" v-if="pageDevice.sensors && Object.entries(pageDevice.sensors).filter(item => item[1].lastValues != null).length != 0" class="deviceListTinkSlideItem p-2 pb-1" :show="uiOption == 'data'">

            <div v-for="(sensor,sensorIndex) in Object.entries(pageDevice.sensors).filter(item => item[1].lastValues != null)" :key="sensor[1].id" :class="(sensorIndex != (Object.entries(pageDevice.sensors).filter(item => item[1].lastValues != null).length-1))? 'mb-1 border-bottom border-gray': ''">

              <div class="d-flex flex-nowrap justify-content-between mb-1" v-for="(value, index) in sensor[1].values.filter(item => item.hold !== true)" :key="index">
                <div class="text-left fontSizeDot8 gothic mr-auto flex-grow-1">
                  <router-link :to="{ name: 'tinkSensor', params: { 'sid': sensor[1].id } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{ value.title }}
                    </span>  
                  </router-link>
                </div>
                <div v-if="value.type == 'string'" class="text-right pr-1 fontSizeDot9 font-weight-bold">
                  {{ sensor[1].lastValues.v[index] }}
                </div>
                <div v-else class="text-right pr-1 fontSizeDot9 font-weight-bold">
                  {{ sensor[1].lastValues.v[index].toLocaleString("ko-KR") }}
                </div>
                <div class="text-left fontSizeDot8 ml-auto">
                  {{ value.unit }}
                </div>
              </div>
            </div>
          </tinkSlideItem>

          <tinkSlideItem name="location" v-if="pageDevice.locationInfo || pageDevice.location" class="deviceListTinkSlideItem p-2 pb-1 fontSizeDot8" :show="uiOption == 'location'">
            <ul class="m-0 p-0 pl-3" style="line-height: 140%;">
              <li v-if="pageDevice.location" class="p-0 pb-1 m-0">
                <router-link v-if="isLoginUserPageUser||isLoginUserAdmin" :to="{ name: 'tinkUser', params: { uid: pageUser.id, mode: 'map', marker: pageDevice.id } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    {{geopointToDMSString(pageDevice.location)}}
                  </span>  
                </router-link>
                <span v-if="!(isLoginUserPageUser||isLoginUserAdmin)" style="color: #0004af; cursor: pointer" @click="openNewGmapWindow(pageDevice.location.latitude, pageDevice.location.longitude)">
                  {{geopointToDMSString(pageDevice.location)}}
                </span>
              </li>
              <li v-if="pageDevice.locationInfo && pageDevice.locationInfo.name && !pageDevice.locationInfo.place_id" class="p-0 pb-1 m-0">
                {{pageDevice.locationInfo.name}}
              </li>
              <li v-if="pageDevice.locationInfo && pageDevice.locationInfo.name && pageDevice.locationInfo.place_id" class="p-0 pb-1 m-0">
                <a :href="`https://www.google.com/maps/place/?q=place_id:${pageDevice.locationInfo.place_id}`" target="_new">{{pageDevice.locationInfo.name}}</a> &nearr;
              </li>
              <li v-if="pageDevice.locationInfo && pageDevice.locationInfo.formatted_address" class="p-0 pb-1 m-0">
                {{pageDevice.locationInfo.formatted_address}}
              </li>
              <li v-if="pageDevice.locationInfo && pageDevice.locationInfo.international_phone_number" class="p-0 pb-1 m-0">
                {{pageDevice.locationInfo.international_phone_number}}
              </li>
              <li v-if="pageDevice.locationInfo && pageDevice.locationInfo.website" class="p-0 pb-1 m-0">
                <a :href="pageDevice.locationInfo.website" target="_new">{{pageDevice.locationInfo.website}}</a> &nearr;
              </li>
            </ul>
          </tinkSlideItem>
        </tinkSlide>
        <div class="m-0 pl-2 pr-2 pt-1 pb-1 border border-top-0 border-secondary fontSizeDot8 gothic text-center narrowText2">
          수정:
          {{
            deviceSensorsLastModifiedDateString(pageDevice)
          }}
        </div>
      </tinkListItem>

      <tinkListItem v-if="sortAndFilteredDevices.length == 0" class="deviceListTinkListItem p-0 m-1">
        <div class="border border-gray p-2 fontSizeDot9 gothic text-center" style="height: 100%;">
          <div class="p-1 mt-4">등록된 기기 없음</div>
        </div>
      </tinkListItem>

    </tinkList>

  </div>
</template>
<script>
  import firebase from "firebase/app";
  import "firebase/auth";
  import "firebase/firestore";
  import { db } from "@/plugins/firebase.js"

  import uiUtil from "@/mixins/util.js"
  import eventBus from "@/plugins/eventBus.js"
  import user from "@/mixins/user.js"

  import { mapActions } from "vuex";

  import userTabs from "@/components/user/userTabs.vue"

  import { tinkList, tinkListItem } from "@/components/common/tinkList.vue"
  import { tinkSlide, tinkSlideItem } from "@/components/common/tinkSlide.vue"

  export default {
    name: "deviceList",
    mixins: [uiUtil, user],
    props: {
      pageBinded: {
        type: Boolean,
        default: false
      },
      pageUser: {
        type: Object,
        default: null
      },
      uid: {
        type: String,
        default: ""
      },
      mode: {
        type: String,
        default: ""
      },
      marker: {
        type: String,
        default: ""
      },
      folder: {
        type: String,
        default: "@root"
      },
    },
    components: {
      userTabs,
      tinkList,
      tinkListItem,
      tinkSlide,
      tinkSlideItem,
    },
    created: function() {
      this.initUi();
    },

    mounted: function() {
      if(this.uiView == "folder" && this.folder == "@friend" && this.isLoginUserPageUser && this.friendDevices == null) {
        this.bindFriendDevices();
      }
      if(this.uiView == "folder" && this.folder == "@oAdmin" && this.isLoginUserPageUser && this.oAdminDevices == null) {
        this.bindOAdminDevices();
      }
      if(this.uiView == "folder" && this.folder == "@admin" && this.isLoginUserPageUser && !this.loginUserDeepBinding && this.adminDevices == null) {
        this.bindAdminDevices();
      }
    },

    updated: function() {
      if(this.uiView == "folder" && this.folder == "@friend" && this.isLoginUserPageUser && this.friendDevices == null) {
        this.bindFriendDevices();
      }
      if(this.uiView == "folder" && this.folder == "@oAdmin" && this.isLoginUserPageUser && this.oAdminDevices == null) {
        this.bindOAdminDevices();
      }
      if(this.uiView == "folder" && this.folder == "@admin" && this.isLoginUserPageUser && !this.loginUserDeepBinding && this.adminDevices == null) {
        this.bindAdminDevices();
      }
    },

    data: function() {
      return {
        uiView: "folder",
        uiViewOptions: [],
        uiOption: "data",
        uiOrderBy: "saved",
        uiKeyword: "",
      }
    },
    methods: {

      bindAdminDevices: function() {
        this.storeBindingAdminDevices().then(() => {
          this.adminDevicesBinded = true;
          window.setTimeout(() => {
            this.unbindAdminDevices();
          }, process.env.VUE_APP_PAGE_TIMEOUT*1);
        });
      },

      unbindAdminDevices: function() {
        this.storeUnbindingAdminDevices().then(() => {
          this.adminDevicesBinded = false;
        });
      },

      bindOAdminDevices: function() {
        this.storeBindingOAdminDevices().then(() => {
          this.oAdminDevicesBinded = true;
          window.setTimeout(() => {
            this.unbindOAdminDevices();
          }, process.env.VUE_APP_PAGE_TIMEOUT*1);
        });
      },

      unbindOAdminDevices: function() {
        this.storeUnbindingOAdminDevices().then(() => {
          this.oAdminDevicesBinded = false;
        });
      },

      bindFriendDevices: function() {
        this.storeBindingFriendDevices().then(() => {
          this.friendDevicesBinded = true;
          window.setTimeout(() => {
            this.unbindFriendDevices();
          }, process.env.VUE_APP_PAGE_TIMEOUT*1);
        });
      },

      unbindFriendDevices: function() {
        this.storeUnbindingFriendDevices().then(() => {
          this.friendDevicesBinded = false;
        });
      },

      toggleAdminDevicesRealtimeChanged: function() {
        if(this.adminDevicesBinded) {
          this.unbindAdminDevices();
        }
        else {
          this.bindAdminDevices();
        }
      },

      toggleOAdminDevicesRealtimeChanged: function() {
        if(this.friendDevicesBinded) {
          this.unbindOAdminDevices();
        }
        else {
          this.bindOAdminDevices();
        }
      },

      toggleFriendDevicesRealtimeChanged: function() {
        if(this.friendDevicesBinded) {
          this.unbindFriendDevices();
        }
        else {
          this.bindFriendDevices();
        }
      },

      initUi: function() {
        this.$set(this, "uiViewOptions", [
          {'text': '폴더별로' , 'value': 'folder' },
          {'text': '내 기기만' , 'value': 'my' },
        ]);

        if(this.isLoginUserPageUser) {
          this.$set(this, "uiViewOptions", [
            {'text': '폴더별로' , 'value': 'folder' },
            {'text': '모든 기기' , 'value': 'all' },
            {'text': '내 기기만' , 'value': 'my' },
            {'text': '관리 기기만' , 'value': 'admin' },
          ]);
        }
        else {
        }
        if(this.$cookies.isKey("uiView")) {
          if(this.uiViewOptions.some(item => item.value == this.$cookies.get("uiView"))) {
            this.uiView = this.$cookies.get("uiView");
          }
        }
        if(this.$cookies.isKey("uiOption")) {
          this.uiOption = this.$cookies.get("uiOption");
        }
        if(this.$cookies.isKey("uiOrderBy")) {
          this.uiOrderBy = this.$cookies.get("uiOrderBy");
        }
      },

      applyUiOption: function() {
        this.$cookies.set('uiOption',this.uiOption);
        this.$refs.tinkList.$children.forEach(item => {
          for(let i=0;i<item.$children.length;i++) {
            if(typeof(item.$children[i].showItemByName) != "undefined") {
              item.$children[i].showItemByName(this.uiOption);
              break;
            }
          }
        })
      },

      applyUiView: function() {
        this.$cookies.set('uiView',this.uiView);
        if(this.uiView != "folder" && this.folder != "@root") {
          this.$router.push({ name: 'tinkUserFolder', params: { 'uid': this.pageUser.id, 'folder': '@root' } })
        }
      },

      applyUiOrderBy: function() {
        this.$cookies.set('uiOrderBy',this.uiOrderBy);
      },

      deviceActiveChanged: function(param) {
        param.srcElement.disabled = "disabled";
        if(param.srcElement.dataset.active == "true") {
          param.srcElement.dataset.active = "false";
        }
        else {
          param.srcElement.dataset.active = "true";
        }

        window.setTimeout(function() {
          param.srcElement.disabled = ""
        }, 5000);

        db.collection("devices")
          .doc(param.srcElement.dataset.did)
          .update({
            active: (param.srcElement.dataset.active == "true")? true: false
          })
          .then(() => {
            if(param.srcElement.dataset.active == "true") {
              this.makeToast("success", "기기 켜기 성공", "[" + this.pageUser.devices[param.srcElement.dataset.did].name +"] 기기의 업로드를 켰습니다.")
            }
            else {
              this.makeToast("success", "기기 끄기 성공", "[" + this.pageUser.devices[param.srcElement.dataset.did].name +"] 기기의 업로드를 껐습니다.")
            }
          })
          .catch(error => {
            if(param.srcElement.dataset.active == "true") {
              this.makeToast("critical", "기기 끄기 실패", "[" + this.pageUser.devices[param.srcElement.dataset.did].name +"] 기기의 업로드를 켜지 못했습니다.")
            }
            else {
              this.makeToast("critical", "기기 끄기 실패", "[" + this.pageUser.devices[param.srcElement.dataset.did].name +"] 기기의 업로드를 끄지 못했습니다.")
            }
          })
      },
      ...mapActions(["storeUnbindingAdminDevices", "storeBindingAdminDevices", "storeBindingOAdminDevices", "storeUnbindingOAdminDevices", "storeBindingFriendDevices", "storeUnbindingFriendDevices"]),
    },

    computed: {

      uiViewFolderFolders: function() {
        if(this.uiView == "folder") {
          if(this.folder == "@root") {
            // if(this.isLoginUserPageUser) return this.loginUser.folders;
            // else return this.pageUser.folders;
            return this.pageUser.folders;
          }
          else {
            return ["@root"];
          }
        }
        else return [];
      },

      sortAndFilteredDevices: function() {

        let list = [];


        if(this.isLoginUserPageUser && this.loginUserDeepBinding) {
          if(this.uiView == "all") {
            list = this.loginUserDeviceArrayAll;
          }
          else if(this.uiView == "my") {
            list = this.loginUserDeviceArray;
          }
          else if(this.uiView == "admin") {
            // bingo ??
            list = this.adminDevices;
          }
          else if(this.uiView == "folder") {

            if(this.folder == "@friend") {
              if(this.friendDevices != null) {
                list = this.friendDevices;
              }
            }
            else if(this.folder == "@oAdmin") {
              if(this.oAdminDevices != null) {
                list = this.oAdminDevices;
              }
            }
            else if(this.folder == "@admin") {
              // bingo ???
              list = this.adminDevices;
            }
            else {
              list = this.loginUserDeviceGroupByFolder[this.folder];
            }
          }
        }
        else if(this.isLoginUserPageUser) {
          if(this.uiView == "all") {
            list = this.pageUserDeviceArrayAll;
          }
          else if(this.uiView == "my") {
            list = this.pageUserDeviceArray;
          }
          else if(this.uiView == "admin") {
            list = this.adminDevices;
          }
          else if(this.uiView == "folder") {
            if(this.folder == "@friend") {
              list = this.friendDevices;
            }
            if(this.folder == "@oAdmin") {
              list = this.oAdminDevices;
            }
            else if(this.folder == "@admin") {
              list = this.adminDevices;
            }
            else {
              list = this.pageUserDeviceGroupByFolder[this.folder];
            }
          }
        }
        else {

          if(this.uiView == "my") {
            list = this.pageUserDeviceArray;
          }
          else if(this.uiView == "folder") {
            if(this.folder != "@friend" && this.folder != "@oAdmin") {
              list = this.pageUserDeviceGroupByFolder[this.folder];
            }
          }
        }

        if(list == null) return list;

        if(this.uiKeyword != "") {
          list = list.filter(item => {
            if(item.name.includes(this.uiKeyword)) return true
            else if(item.description.includes(this.uiKeyword)) return true
            else if(item.locationInfo != null && item.locationInfo.name.includes(this.uiKeyword)) return true
            return false
          })
        }

        if(this.uiOrderBy =="saved") {
          if(this.uiView != "folder" || (this.folder != "@admin" && this.folder != "@friend" && this.folder != "@oAdmin")) {

            list.sort((a,b) => {
              if(!this.pageUser.foldersInfo) return 0;
              else if(typeof(a) == "string") {
                return this.pageUser.foldersInfo[a.split("/")[1]].index - this.pageUser.foldersInfo[b.split("/")[1]].index;
              }
              else {
                return this.pageUser.foldersInfo[a.id].index - this.pageUser.foldersInfo[b.id].index;
              }
            })

          }
        }

        else if(this.uiOrderBy == "modified") {
          list.sort((a,b) => {
            return (this.deviceSensorsLastModified(b).seconds - this.deviceSensorsLastModified(a).seconds);
          });
        }

        else if(this.uiOrderBy == "row") {
          list.sort((a,b) => (this.deviceSensorsRowCount(b) - this.deviceSensorsRowCount(a)));
        }

        else if(this.uiOrderBy == "created") {
          list.sort((a,b) => (b.creation.seconds - a.creation.seconds));
        }

        else if(this.uiOrderBy == "name") {
          list.sort((a,b) => (a.name.localeCompare(b.name, this.getLang())));
        }

        return list;
      },
    },

    watch: {
      uid: function() {
        this.initUi();
        window.setTimeout(() => {
          this.applyUiOption();
        }, 100)
      },
    },

  }
</script>
<style>
  .deviceListTinkSlide { padding: 0px; }
  .deviceListTinkSlideItem { width: 100%; min-height: 9rem; overflow : auto; line-height: 1.4rem; }

  .deviceListTinkListItem {
    min-width: 12rem;
    max-width: 22rem;
    min-height: 9rem;
  }

  .deviceListTinkListFolderItem {
    min-width: 12rem;
    max-width: 22rem;
  }

  .device-title { color: #2100ab; font-size: 1.2rem; font-weight: bold; }

  .device-title a { color: #2100ab; font-size: 1.7ex; font-weight: bold; }

  .tinkSlideItemPhoto { object-fit: cover; width: 100%; height: 9rem; }

  .deviceListTinkSlideNext { bottom: 0.4rem; right: 0.4rem; width: 1.6rem; height: 1.6rem; }
  .deviceListTinkSlideNext button { border-radius: 0.8rem; font-size: 0.8rem; }
</style>
